import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

const PrivateRoute = ({ isAuthenticated, isLanguage, children }) => {
  const { oktaAuth } = useOktaAuth();
  const location = useLocation();

  if (isAuthenticated && isLanguage) return children;

  if (!isAuthenticated) {
    // Tell Okta where to send the user after login.
    // LoginCallback at /authenticate will call restoreOriginalUri with this value.
    oktaAuth.setOriginalUri(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // Authenticated but profile/language not yet loaded — wait
  return null;
};

export default PrivateRoute;
